import React from "react";
import { Input, Select, ConfigProvider, Flex } from "antd";
import "./SearchBar.scss";
import { ReactComponent as Search } from "../../assets/Icons/Search.svg";

const { Option } = Select;

const SearchBar = ({
  categories = [
    { value: "supervisor", label: "Supervisor" },
    { value: "field_agent", label: "Field Agent" },
    { value: "telecaller", label: "Telecaller" },
    { value: "team_lead", label: "Team Lead" },
  ],
  defaultCategory = "User role",
  placeholder = "Search",
  onSearch,
  onCategoryChange,
  onInputChange,
  inputValue,
}) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            colorBgContainer: "#1c1c1c",
            colorTextPlaceholder: "#A6A6A6",
            colorText: "#fff",
            fontFamily: "Gilroy",
          },
          Select: {
            colorBgContainer: "#1c1c1c",
            colorTextPlaceholder: "#A6A6A6",
            colorText: "#fff",
            fontFamily: "Gilroy",
            colorPrimary: "#FFF",
          },
        },
      }}
    >
      <Flex className="search-card">
        <Select
          defaultValue={defaultCategory}
          bordered={false}
          style={{ minWidth: 150 }}
          onChange={onCategoryChange}
          options={categories}
        />

        <Input
          placeholder={placeholder}
          bordered={false}
          style={{ flex: 1 }}
          onChange={onInputChange}
          value={inputValue}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onSearch?.();
            }
          }}
        />

        <button
          type="button"
          className="custom-search-button"
          onClick={onSearch}
        >
          <Search />
        </button>
      </Flex>
    </ConfigProvider>
  );
};

export default SearchBar;
